<template>
    <div class="row featured-items mt-4" v-show="aItems.length > 0">
        <div class="col-12 mobile-title text-center" :class=" !isMobile ? 'py-3' : 'pt-2 pb-3'">
            <strong class="fs-30 color-primary-n">Productos destacados</strong>
        </div>

        <div v-if="!isMobile" class="col-12 mb-4">
            <carousel :autoplay="false"
                      :dots="false"
                      :items="5"
                      :loop="true"
                      :margin="24"
                      :nav="false"
                      :responsive="carouselResponsive"
                      v-if="!isLoadingData">

                <template slot="prev">
                    <span class="prev btn-slide owl-prev-btn">
                        <i class="fe-arrow-left-circle fs-30"></i>
                    </span>
                </template>

                <div class="gallery-item" v-for="(item, index) in aItems"
                                          :key="'pi_' + index">
                    <div class="gallery-item-image-container cursor-pointer" @click="goItemDetail(item)">
                        <img class="gallery-item-image" :src="item.mainImage.path" :alt="item.name">
                    </div>
                    <div class="gallery-item-details">
                        <span class="gallery-item-name fs-20 color-primary-n cursor-pointer" @click="goItemDetail(item)">{{ item.name }}</span>
                        <span class="subname">{{ item.subname }}</span>
                        <div class="gallery-item-value fs-18 cursor-pointer" @click="goItemDetail(item)">
                            {{ item.price | moneyFilter }}
                            <span class="offert-price" v-if="item.e_base_offer_price > 0">{{ item.e_base_offer_price | moneyFilter }}</span>
                        </div>
                        <div class="row mt-2">
                            <div class="col-5 pr-0">
                                <inertia-link :href="route('item.detail', item.id)" as="button" class="btn btn-block btn-secondary-n">Ver</inertia-link>
                            </div>

                            <div class="col-7">
                                <button class="btn btn-block btn-primary-n"
                                        @click.prevent="buyItem(item)">
                                    Comprar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <template slot="next">
                    <span class="next btn-slide owl-next-btn">
                        <i class="fe-arrow-right-circle fs-30"></i>
                    </span>
                </template>
            </carousel>
        </div>

        <div class="col-12" v-else>
            <div v-for="(item, index) in aMobileItems" :key="'fi_' + index" class="featured-item">
                <div class="featured-item-image cursor-pointer" @click="goItemDetail(item)">
                    <img :src="item.mainImage.path" :alt="item.name">
                </div>
                <div class="featured-item-info">
                    <h4 class="fi-title color-primary-n cursor-pointer" @click="goItemDetail(item)">{{ item.name | nameLengthFilter }}</h4>
                    <span class="subname">{{ item.subname }}</span>
                    <span class="fi-price cursor-pointer" @click="goItemDetail(item)">
                        {{ item.price | moneyFilter }}
                        <span class="offert-price" v-if="item.e_base_offer_price > 0">{{ item.e_base_offer_price | moneyFilter }}</span>
                    </span>
                    <div class="featured-item-options">
                        <inertia-link :href="route('item.detail', item.id)" as="button" class="featured-item-eye"><i class="fe-eye"></i></inertia-link>

                        <a class="featured-item-cart"
                           @click.prevent="buyItem(item)">
                            <i class="fe-shopping-cart"></i>
                        </a>
                    </div>
                </div>
            </div>
            <div class="load-more-button" @click="loadMoreItems()" v-if="aItems.length != aMobileItems.length">Cargar más...</div>
        </div>

        <div class="col-12 text-center">
            <loader-c :absolute="false"
                      v-if="isLoadingData">
            </loader-c>
        </div>

    </div>
</template>

<script>
import { mapActions } from 'vuex';

import Carousel from 'vue-owl-carousel';

import filtersMixin from '../../../mixins/filtersMixin';
import fileRootPathMixin from '../../../mixins/fileRootPathMixin';
import itemMainImageMixin from '../../../mixins/itemMainImageMixin';

import LoaderC from '../../Shared/General/LoaderComponent.vue';

import { checkCatch, showMessage } from '../../../utils';
import { ITEM_TYPES } from '../../../globlas';

const INITIAL_FEATURED_ITEMS_TO_SHOW = 2;
const LOAD_MORE_FEATURED_ITEMS = 2;

export default {

    components: {

        Carousel,
        LoaderC,

    },

    mixins: [

        filtersMixin,
        fileRootPathMixin,
        itemMainImageMixin,

    ],

    props: {

        loadFromCache: {

            type: Boolean,
            default: false,

        },

    },

    data() {

        return {

            isLoadingData: true,

            isMobile: String(),

            aItems: [],

            aMobileItems: [],

            carouselResponsive: {

                0: {
                    items: 1,
                },

                750: {
                    items: 2,
                },

                980: {
                    items: 3,
                },

                1366: {
                    items: 4,
                },

            },

        };

    },

    mounted() {

        if (!this.loadFromCache) {

            this.loadPreferredItems();

        } else {

            this.loadPreferredFromCache();

        }

    },

    methods: {

        ...mapActions([

            'addItemToShoppingCart',

        ]),

        loadPreferredItems() {

            axios
                .get('/inventory/items/preferred')
                .then((response) => {

                    const { data } = response;

                    if (!data.success) {

                        showMessage('error', 'Atención', data.message);
                        return;

                    }

                    this.aItems = data.data.map((item) => {

                        item.mainImage = this.getItemMainImage(item);

                        return item;

                    });

                    localStorage.setItem('preferred_items', JSON.stringify(this.aItems));

                    if (this.isMobile) {

                        this.aMobileItems = this.aItems.slice(0, INITIAL_FEATURED_ITEMS_TO_SHOW);

                    }

                    this.isLoadingData = false;

                    setTimeout(() => {

                        $('.owl-prev-btn').parent().css('display', 'block');

                    }, 100);

                })
                .catch((error) => {

                    checkCatch(error);

                });

        },

        loadPreferredFromCache() {

            const aItems = JSON.parse(localStorage.getItem('preferred_items'));

            if (aItems) { // Si existen los asigno

                this.aItems = aItems;

                this.isLoadingData = false;

                if (!this.isMobile) {

                    setTimeout(() => {

                        $('.owl-prev-btn').parent().css('display', 'block');

                    }, 100);

                } else {

                    this.aMobileItems = this.aItems.slice(0, INITIAL_FEATURED_ITEMS_TO_SHOW);

                }

            } else { // Sino los consulto de bd y los mando a caché

                this.loadPreferredItems();

            }

        },

        loadMoreItems() {

            const moreItems = this.aItems.slice(this.aMobileItems.length, this.aMobileItems.length + LOAD_MORE_FEATURED_ITEMS);
            this.aMobileItems = this.aMobileItems.concat(moreItems);

        },

        buyItem(itemSelected) {

            if (itemSelected.is_variation == 1) {

                this.$inertia.visit(this.route('item.detail', itemSelected.id));

                return;

            }

            const item = {

                id: itemSelected.id,
                uuid: itemSelected.uuid,
                code: itemSelected.code,
                reference: itemSelected.reference,
                inventoriable: itemSelected.inventoriable,
                inventory_quantity: itemSelected.inventory_quantity,
                quantity: 1,
                main_image: itemSelected.mainImage.path,
                name: itemSelected.name,
                price: itemSelected.price,
                price_no_tax: itemSelected.price_no_tax,
                tax_description: itemSelected.tax_desc,
                tax_id: itemSelected.tax_id,
                tax_percentage: itemSelected.tax_per,
                tax_type: itemSelected.tax_type,
                is_package: itemSelected.is_package,
                is_subscription: itemSelected.is_subscription,
                sub_freq: itemSelected.sub_freq,
                is_virtual: itemSelected.e_item_type == ITEM_TYPES.VIRTUAL,

            };

            this.addItemToShoppingCart(item);

            this.$inertia.visit(this.route('shopping.cart'));

        },

        goItemDetail(itemSelected) {

            if (itemSelected.id) {

                this.$inertia.visit(this.route('item.detail', itemSelected.id));

            }

        },

    },

};
</script>

<style>
.owl-carousel .owl-item img {
    display: block;
    width: auto;
}
</style>
